import __request__ from "routing/request";
export function dataNodes(sort = "hostname", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/system/cluster/datanodes", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
